module.exports = __webpack_public_path__ + "media/packs/images/notification/update-981fb62781e5351f825665bfc77773b0.svg";